import _extends from 'babel-runtime/helpers/extends';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import _Object$entries from 'babel-runtime/core-js/object/entries';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';

import 'echarts/lib/chart/bar';

function deepAssign(a, b) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(_Object$entries(b)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = _slicedToArray(_ref, 2);

      var key = _ref2[0];
      var value = _ref2[1];

      if (!b[key] || !(b[key] instanceof Object) || !(value instanceof Object) || Array.isArray(b[key]) && Array.isArray(value)) {
        a[key] = value;
      } else {
        deepAssign(a[key], b[key]);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return a;
}

export default {
  props: {
    barData: {
      type: Object,
      default: function _default() {}
    }
  },

  computed: {
    computedOptions: function computedOptions() {
      var baseConfig = {
        tooltip: {
          // 提示器
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          // 直角坐标系
          top: '6%',
          left: '3%',
          right: '3%',
          bottom: '6%',
          containLabel: true
        },
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [120, 200, 150, 80, 70, 110, 130],
          type: 'bar',
          barCategoryGap: '40%',
          itemStyle: {
            color: '#B3CC6B'
          }
        }]
      };
      var seriesStyle = {
        type: 'bar',
        barCategoryGap: '40%',
        barMaxWidth: '45px',
        itemStyle: {
          color: '#B3CC6B'
        }
      };
      var config = deepAssign(baseConfig, _Object$assign({}, this.barData.option));
      // series样式保留
      config.series.forEach(function (item, index) {
        config.series[index] = _extends({}, item, seriesStyle);
      });
      return config;
    }
  }
};